/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
    });
  }

  // GK-HUB: Add agent(s) to inbox without replacing existing members
  addAgents({ inboxId, userIds }) {
    return axios.post(this.url, {
      inbox_id: inboxId,
      user_ids: userIds,
    });
  }
}

export default new InboxMembers();
